export default "__VITE_ASSET__ps2J_G3w__"